/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Env03(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("./models/environment/cubes/env_03.glb");
  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="env_03"
          castShadow
          receiveShadow
          geometry={nodes.env_03.geometry}
          material={materials["env_03.003"]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={6.86}
        />
      </group>
    </group>
  );
}

useGLTF.preload("./models/environment/cubes/env_03.glb");
